<template>
  <div>
    <select v-model.number="selectedId">
      <option value="">-- 이벤트 선택 --</option>
      <option
        v-for="event in eventList"
        :key="event.id"
        :value="event.id"
      >
        {{ event.title }} ({{ event.uuid }})
      </option>
    </select>

    <a
      v-show="selectedId"
      :href="`https://article21.kr/event/${selectedId}`"
      target="_blank"
      style="display: inline-block; margin-top: 4px;"
    >
      이벤트 보기
    </a>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, defineProps, defineEmits } from 'vue';
import { apiClient } from '@/services/auth-header';

const eventList = ref([]);

const props = defineProps({
  contentId: { type: [String, Number], default: '' },
});
const emit = defineEmits(['update:contentId']);

const selectedId = computed({
  get: () => props.contentId,
  set: (value) => emit('update:contentId', value),
});

const fetchEventList = async () => {
  try {
    const response = await apiClient.get('/contents/articles/events');
    eventList.value = response.data;
  } catch (error) {
    console.error('이벤트 목록 조회 실패:', error);
  }
};

onMounted(() => {
  fetchEventList();
});
</script>

<style scoped>
select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
</style>
